import React from 'react'
import styles from './styles.css'
import Paginated from 'meteor-paginated-graphql-react'
import autobind from 'autobind-decorator'
import {withRouter} from 'react-router'
import PropTypes from 'prop-types'
import Loading from 'orionsoft-parts/lib/components/Loading'
import moment from 'moment'
import withOrganization from 'App/Decorators/withOrganization'
import GoEye from 'react-icons/lib/go/eye'
import {isMobile} from 'src/App/components/Devices/mediaCheckers'
import Tooltip from 'orionsoft-parts/lib/components/Tooltip'
import filter from 'lodash/filter'
import MdInfo from 'react-icons/lib/md/info'
import MdRemoveCircle from 'react-icons/lib/md/remove-circle'
import MdCheckCircle from 'react-icons/lib/md/check-circle'
import MdCheck from 'react-icons/lib/md/check'
import SignersStatus from '../Common/SignersStatus'

@withOrganization
@withRouter
export default class ViewerDocuments extends React.Component {
  static propTypes = {
    organization: PropTypes.object,
    router: PropTypes.object
  }

  @autobind
  onSelect({_id}) {
    this.props.router.push(`/documents/${_id}`)
  }

  getFields() {
    if (isMobile()) {
      return [
        {title: '', name: '_id', render: () => <GoEye size={20} />},
        {title: 'Nombre', name: 'name'}
      ]
    }
    return [
      {
        title: '', 
        name: 'documentStatus{status}',
        render: () => <GoEye size={20} />
      },
      {title: 'Nombre', name: 'name'},
      {
        title: 'Firmas',
        name: 'signersStatus{email, didSign}, feasStatus{email, didSign}, biosStatus{email, didSign}, faceStatus{email, didSign}' ,
        render: ({signersStatus, feasStatus, biosStatus, faceStatus}) =>
          SignersStatus(signersStatus, feasStatus, biosStatus, faceStatus)
      },
      {
        title: 'Fecha',
        name: 'createdAt',
        render: ({createdAt}) => moment(createdAt).format('DD/MM/YYYY HH:mm'),
        defaultSort: 'DESC',
        sort: 'DESC'
      },
      {
        title: 'Tags',
        name: 'tags',
        render: ({tags}) => tags.join(" ")
      }
    ]
  }

  renderSignerStatus(signersStatus, documentStatus) {
    const pendingSigns = filter(signersStatus, signerStatus => signerStatus.didSign).length
    if (documentStatus.status === 'personal') {
      return (
        <div>
          <div className="row">
            <div className="col-xs-12 col-sm-3">
              <MdCheckCircle size={17} style={{color: '#3CB371'}} />
            </div>
            <div className="col-xs-12 col-sm-8">Own</div>
          </div>
        </div>
      )
    }
    return (
      <div>
        <div className="row">
          <div className="col-xs-12 col-sm-3">
            <Tooltip content={this.renderTooltipContent(signersStatus)}>
              {this.renderTooltip(pendingSigns, signersStatus)}
            </Tooltip>
          </div>
          <div className="col-xs-12 col-sm-8">
            <span>
              {pendingSigns} de {signersStatus.length}
            </span>
          </div>
        </div>
      </div>
    )
  }

  renderTooltip(pendingSigns, signersStatus) {
    if (signersStatus.length === 0) {
      return <MdRemoveCircle size={17} style={{color: '#e4ac00'}} />
    }
    if (pendingSigns === signersStatus.length) {
      return <MdCheckCircle size={17} style={{color: '#3CB371'}} />
    }
    return <MdInfo size={17} />
  }

  renderTooltipContent(signersStatus) {
    if (signersStatus.length === 0) {
      return <p> Documento sin firmantes</p>
    }
    return signersStatus.map((signerStatus, key) => {
      return (
        <p key={key}>
          {signerStatus.didSign && <MdCheck style={{color: 'green', marginRight: 5}} />}
          {signerStatus.email}
        </p>
      )
    })
  }

  render() {
    return (
      <div className={styles.container}>
        <div className="section">
          <div className="table">
            <Paginated
              loadingComponent={Loading}
              queryName="viewerDocuments"
              fields={this.getFields()}
              defaultLimit={25}
              params="$filter: String $organization: String"
              organization={this.props.organization._id}
              onPress={this.onSelect}
            />
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Documents/ViewerDocuments/index.js